import {
  GET_CUSTOMERS_REQUESTED,
  GET_CUSTOMERS_SUCCEEDED,
  GET_CUSTOMERS_FAILED,
  SEARCH_CUSTOMER_SUCCEEDED,
  SELECT_CUSTOMER,
  UPDATE_TOGGLE
} from './constants'
import api from '../../utils/api'

export const searchCustomer = (payload) => ({
  type: SEARCH_CUSTOMER_SUCCEEDED,
  payload
})

export const getCustomersRequested = () => ({
  type: GET_CUSTOMERS_REQUESTED
})

export const getCustomersSucceeded = payload => ({
  type: GET_CUSTOMERS_SUCCEEDED,
  payload
})

export const getCustomersFailed = () => ({
  type: GET_CUSTOMERS_FAILED
})

export const selectCustomer = (id) => ({
  type: SELECT_CUSTOMER,
  payload: id
})

export const updateToggle = (key, value) => ({
  type: UPDATE_TOGGLE,
  payload: { key, value }
})

export const loadCustomers = (venueUuid) => dispatch => {
  dispatch(getCustomersRequested())

  return api
    .fetchCustomers(venueUuid)
    .then(response => {
      return dispatch(getCustomersSucceeded(response.data.customers))})
    .catch(() => dispatch(getCustomersFailed()))
}

export const onSelectCustomer = (customerId) => dispatch => {
  dispatch(selectCustomer(customerId))
}
